import { Window } from "@progress/kendo-react-dialogs";
import React from "react";
import { columnMenuProps } from "src/components/customColumnMenu";
import DataTable from "src/components/dataTable";
import { GridColumn as Column } from "@progress/kendo-react-grid";
import { getfilterDataString } from "src/utils/utils";
import { DEFAULT_SORT } from "src/constants/grid";

const BusinessGroupPopup = (props) => {

    const { businessGroupData, setShow, isShow, onColumnMenuChange } = props;
    const rows = businessGroupData?.data || [];
    const columns = businessGroupData?.columns || [];

    const [filterData, setFilterData] = React.useState({
        isFilter: false,
        isSort: false,
        data: "",
        in_sort_number: 8,
        sort_order: "DESC",
    });
    const [sortField, setSortField] = React.useState([]);
    const [filterField, setFilterField] = React.useState({ logic: "and", filters: [] });
    const [isAPICalling, setAPICallingState] = React.useState(false);

    const StringReadOnlyCell = React.useCallback((props) => {
        const { ariaColumnIndex, columnIndex, dataItem, field } = props;
    
        let val = dataItem[field || ""];
    
        const defaultRendering = (
          <td aria-colindex={ariaColumnIndex} data-grid-col-index={columnIndex}>
            <span title={val}>{val}</span>
          </td>
        );
    
        return defaultRendering;
      }, []);

      const getInSortNumber = () => {
        return filterData.isSort ? filterData.in_sort_number : 8;
      };
    
      const getInSortOrder = () => {
        return filterData.isSort ? filterData.sort_order : 'DESC';
      };
      
    const businessGroupUseCol = () => {
        return columns.map((column, idx) => {
          return column.show && column.title !== "" ? (
            <Column {...columnMenuProps(column)} key={idx} sortable={true} width={150} cell={StringReadOnlyCell} />
          ) : (
            false
          );
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
      };
    
      let BusinessGroupColumn = businessGroupUseCol();

    const onClosePopup = () => {
        setShow((prev) => ({
          ...(isShow || prev),
          viewBusinessGroups: false,
        }));

        // Reset popup dataset back to default (unfiltered + default sort)
        // so reopening always starts with original data.
        if (onColumnMenuChange) {
          onColumnMenuChange({
            in_filter: null,
            in_sort_number: 8,
            in_sort_order: "DESC",
          });
        }
    };

    const handleColumnMenu = async (columnMenuData, isFilter, isSort, filterObj) => {
      let data = rows;
      if (isSort) {
        setSortField(columnMenuData);
      } else {
        setFilterField(filterObj);
      }
      let index = 1;
    

      if (data.length > 0 && columnMenuData[0] !== undefined) {
        let obj = Object.keys(data[0]);
        index = obj.findIndex((x) => x === columnMenuData[0].field) + 1;
      }
  
      const filterString = isFilter ? getfilterDataString(columnMenuData, columns) : filterData.data;
  
      isFilter = false;
      if (filterString !== "") {
        isFilter = true;
      }
  
      let sortDir = filterData.isSort && columnMenuData.length ? filterData.sort_order :"DESC";
      let sortNumber = filterData.isSort && columnMenuData.length ? filterData.in_sort_number : 8;
  
      isSort = !columnMenuData.length ? false : filterData.isSort;
  
      if (columnMenuData[0] !== undefined && columnMenuData[0].dir !== undefined) {
        isSort = true;
        sortDir = columnMenuData[0].dir.toUpperCase();
        sortNumber = index;
      }
      let filterVal = "";
     

      setFilterData({
        ...filterData,
        isFilter: isFilter,
        isSort: isSort,
        data: filterString,
        in_sort_number: sortNumber,
        sort_order: sortDir,
      });
      setAPICallingState(true);
      try {
        if (onColumnMenuChange) {
          await onColumnMenuChange({
            in_filter: isFilter ? filterString : null,
            in_sort_number: sortNumber,
            in_sort_order: sortDir,
          });
        }
      } finally {
        setAPICallingState(false);
      }
    };


    const onClearFilter = async () => {
      setAPICallingState(true);
      setFilterField({ logic: "and", filters: [] });
      //set in_params
      const dataVal = {
        in_filter: "",
        in_sort_number: getInSortNumber(),
        in_sort_order: getInSortOrder(),
      };
  
      //set filter to false
      setFilterData({
        ...filterData,
        data: "",
        isFilter: false,
      });
      try {
        if (onColumnMenuChange) {
          await onColumnMenuChange({
            in_filter: null,
            in_sort_number: dataVal.in_sort_number,
            in_sort_order: dataVal.in_sort_order,
          });
        }
      } finally {
        setAPICallingState(false);
      }
    };

    return (
        <>
            <Window title={"Business Group List"} onClose={onClosePopup} width={600} height={480} modal={true}>
                <div className="dtu-file-container-logs">
                  {columns.length > 0 && (
                    <DataTable
                        isAPICalling={isAPICalling}
                        initialLoading={true}
                        data={rows}
                        dataCount={rows.length}
                        customColumn={BusinessGroupColumn}
                        columns={columns}
                        isDragMode={false}
                        isPagination={false}
                        gridHeight={"340px"}
                        handleColumnMenu={handleColumnMenu}
                        initialFilter={filterField}
                        initialSort={sortField}
                        onClearFilter={onClearFilter}
                        reorderable={false}
                        
                    />
                    )}
                </div>
            </Window>
        </>
    );
};

export default BusinessGroupPopup;